import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import GrooveGlowIntro from './components/GrooveGlowIntro';
import EcosystemMap from './components/EcosystemMap';
import DualProgram from './components/DualProgram';
import ConnectionFlow from './components/ConnectionFlow';
import Positioning from './components/Positioning';
import WorkshopFlow from './components/WorkshopFlow';
import Realms from './components/Realms';
import Technology from './components/Technology';
import Outcomes from './components/Outcomes';
import Credibility from './components/Credibility';
import Customization from './components/Customization';
import VisualProof from './components/VisualProof';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-black text-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/608739ad275fa1872f248bce8cdb3f04/258b7d4ee82ef280bfbbf1f32807923c.png" 
              alt="SkinS Team Building Workshop" 
              className="h-12 w-auto"
            />
            <span className="text-xl font-bold">SkinS Workshop</span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#overview" className="text-sm hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">Overview</a>
            <a href="#experience" className="text-sm hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">Experience</a>
            <a href="#technology" className="text-sm hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">Technology</a>
            <a href="#outcomes" className="text-sm hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">Outcomes</a>
            <a href="#contact" className="px-6 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full text-sm font-semibold hover:shadow-lg hover:shadow-orange-500/50 transition-all cursor-pointer whitespace-nowrap">Get Proposal</a>
          </div>
        </div>
      </nav>

      <Hero />
      <GrooveGlowIntro />
      <EcosystemMap />
      <DualProgram />
      <ConnectionFlow />
      <Positioning />
      <WorkshopFlow />
      <Realms />
      <Technology />
      <Outcomes />
      <Credibility />
      <Customization />
      <VisualProof />
      <FAQ />
      <ContactForm />
      <Footer />
    </div>
  );
}
